import { call, put, takeEvery } from "redux-saga/effects";
import * as StreamingActions from "./streaming.actions";
import StreamingAPI from "./streaming.api";
import { StreamingActionTypes } from "./streaming.model";

export function* handleGetToken(action) {
    try {
        const response = yield call(StreamingAPI.getAppToken, action.payload);
        yield put(StreamingActions.fetchAppTokenSuccess(response));
    } catch (e) {
        yield put(StreamingActions.fetchAppTokenFailure(e));
    }
}

export function* handleCreateRoom(action) {
    try {
        const response = yield call(StreamingAPI.createNewRoom, action.payload);
        yield put(StreamingActions.createRoomSuccess(response));
    } catch (e) {
        yield put(StreamingActions.createRoomFailure(e));
    }
}

export function* handleGetSessions(action) {
    try {
        const response = yield call(StreamingAPI.createNewRoom, action.payload);
        const response1 = yield call(StreamingAPI.getSessions, response.id);
        yield put(StreamingActions.fetchSessionSuccess(response1));
    } catch (e) {
        yield put(StreamingActions.fetchSessionFailure(e));
    }
}

export function* StreamingSaga() {
    yield takeEvery(StreamingActionTypes.GET_APP_TOKEN_REQUEST, handleGetToken);
    yield takeEvery(StreamingActionTypes.CREATE_ROOM_REQUEST, handleCreateRoom);
    yield takeEvery(
        StreamingActionTypes.GET_SESSIONS_REQUEST,
        handleGetSessions
    );
}
